<div class="rs-resume-owners-information">
  <div *ngFor="let owner of cachedIndividuals">
    <rs-owner [owner]="owner" [isIndividual]="true" [hideDelete]="true"></rs-owner>
  </div>
  <div *ngFor="let owner of cachedCompanies">
    <rs-owner [owner]="owner" [hideDelete]="true"></rs-owner>
  </div>
</div>
